import httpClient from './httpClient';

export async function getUserData(userID: string) {
  try {
    const response = await httpClient.get(`/api/users/${userID}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao obter dados do usuário:', error);
    throw new Error('Erro ao obter dados do usuário: ' + error);
  }
}
